export class UserRegisterDetails{
    public constructor(
        public firstName?:string,
        public surname?:string,
        public username?:string,
        public password?:string
    ){}
}